export class AddCompain {
    expenseId: number = 0;
    categoryId: number = 0; 
    index: number = 0; 
    subproduct: boolean = false; 
    category: any = null; 
    indexProd: number = 0;; 
    event: HTMLElement = null; 
    noCat: boolean = false;
    constructor () {}

    public setData (expenseId:number,categoryId:number,index:number,category:any,event:HTMLElement) {
        this.expenseId = expenseId;
        this.categoryId = categoryId;
        this.index = index;
        this.category = category;
        this.event = event;
        this.noCat = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/right-panel/class/add-compain.ts